import { useGtm } from '@gtm-support/vue-gtm';

import { defineNuxtRouteMiddleware } from '#imports';

export default defineNuxtRouteMiddleware((to) => {
  const gtm = useGtm();
  gtm?.trackEvent({ event: 'page_view', value: { page_title: to.name, page_location: to.path } });
});
